import {
  AspectRatio,
  Box,
  Center,
  Heading,
  Text,
} from "@chakra-ui/react";
import LineSection from "../lineSection";
import Lang from "../../Lang";

export default function HeroHome() {
  return (
    <>
      <Box
        mb={{ base: "80px", md: "190px", lg: "170px", xl: "210px" }}
      >
        <LineSection />

        <Box>
          <AspectRatio
            ratio={{ base: 3 / 5, md: 1, xl: 2 / 1 }}
            h={{base:"600px",md:"1000px"}}
          >
            <video
              loop="true"
              autoplay="true"
              playsinline="true"
              muted="true"
            >
              <source
                src="media/1605253_Backgrounds_Abstract_Pattern_3840x2160.mp4"
                type="video/mp4"
              />
            </video>
          </AspectRatio>

          <Box
            className="headingTop"
            h={{ base: "400px", md: "600px", lg: "600px",xl: "500px" }}
          >
            <Heading
              as="h1"
              color={"#fff"}
              align={"center"}
              fontSize={{ base: "4em", md: "5em", lg: "6em", xl: "8em" }}
              className="barlow-black"
            >
              <Lang text={"Social Initiatives"} />
            </Heading>

            <Center>
              <Box
                w={{ base: "xl", md: "4xl", xl: "6xl" }}
              >
                <Text
                  color='white'
                  pt={{ base: 16, md: "80px" }}
                  pb={{ base: "30px", md: "20px",  xl: "100px" }}
                  px={{ base: "10px" }}
                  fontSize={{ base: "1.5em", md: "3em", xl: "3em" }}
                  fontWeight={"bold"}
                  align={"center"}
                >
                  <Lang text={"Building a better place with young programming enthusiasts from socially vulnerable populations in Latin America."} />
                </Text>
              </Box>
            </Center>

          </Box>

        </Box>
      </Box>
    </>
  );
}